import { DefaultTheme } from 'styled-components';

export const lightTheme: DefaultTheme = {
  color: {
    main: {
      primary: 'blue',
      secondary: 'red',
    },
    bg: {
      default: 'white',
      hover: '#eee',
      tag: 'rgba(0,0,0,.7)',
      icon: '#ccc',
      primary: '#eee',
    },
    icon: {
      default: '#aaa',
    },
    font: {
      primary: 'black',
      secondary: '#65675b',
    },
    logo: {
      primary: '#4267B2',
      LightBlue: '#00B2FF',
      Blue: '#006AFF',
    },
  },
};
